<div class="container">
  <div class="container__title" *ngIf="title">{{ title }}</div>
  <div class="container__content"><ng-content></ng-content></div>
</div>
